const init = () => {

  const cardsToggle = document.querySelectorAll(`[data-cards-toggle]`)

  for (const item of cardsToggle) {
    
    item.addEventListener(`click`, e => {
      e.preventDefault()
      document.querySelector(`[data-cards="${item.dataset.cardsToggle}"]`).classList.remove(`is-hidden`)
      item.classList.add(`is-hidden`)
    })

  }

}

export default {
  init
}
